import React from "react";

function EditorConfig() {
  return <></>;
}

export const editorOptions = {
  defaultTag: "div",
  mode: "classic",
  rtl: false,
  katex: "window.katex",
  font: ["Arial", "Comic Sans MS", "Courier New", "Impact", "Georgia", "Tahoma", "Trebuchet MS", "Verdana", "Logical", "Garamond", "Sans-Serif", "Serif", "Times New Roman", "Helvetica"],
  fontSize: [8, 10, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48, 72],
  formats: ["p", "blockquote", "h1", "h2", "h3"],
  colorList: [
    ["#ffa7a7", "#ffc19e", "#faed7d", "#cef279", "#b2ebf4", "#b2ccff", "#d1b2ff", "#ffb2f5", "#bdbdbd"],
    ["#f15f5f", "#f29661", "#e5d85c", "#bce55c", "#5cd1e5", "#6699ff", "#a366ff", "#f261df", "#8c8c8c"],
    ["#ff0000", "#ff5e00", "#ffe400", "#abf200", "#00d8ff", "#0055ff", "#6600ff", "#ff00dd", "#5a5757"],
    ["#980000", "#993800", "#998a00", "#6b9900", "#008299", "#003399", "#3d0099", "#990085", "#353535"],
    ["#670000", "#662500", "#665c00", "#476600", "#005766", "#002266", "#290066", "#660058", "#222222"],
  ],
  imageUploadUrl: "",
  imageGalleryUrl: "https://etyswjpn79.execute-api.ap-northeast-1.amazonaws.com/suneditor-demo",
  videoFileInput: false,
  videoUploadUrl: "",
  audioFileInput: true,
  audioWidth: "",
  audioHeight: "",
  audioUploadUrl: "",
  tableCellControllerPosition: "",
  hrItems: [
    {
      name: "Outset",
      style: "border-style: outset;",
    },
  ],
  tabDisable: false,
  linkTargetNewWindow: true,
  lineHeights: [
    {
      text: "Single",
      value: 1,
    },
    {
      text: "Double",
      value: 2,
    },
  ],
  paragraphStyles: [
    "spaced",
    {
      name: "Box",
      class: "_se_customClass",
    },
  ],
  textStyles: [
    "translucent",
    {
      name: "Emphasis",
      style: "-webkit-text-emphasis: filled;",
      tag: "span",
    },
  ],
  placeholder: "Enter contents here ...",
  icons: {
    paragraph_style: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"/><path d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/></svg>',
  },
  buttonList: [
    ["undo", "redo"],
    ["font", "fontSize", "formatBlock"],
    ["paragraphStyle", "blockquote"],
    ["bold", "underline", "italic", "strike", "subscript", "superscript"],
    ["fontColor", "hiliteColor", "textStyle"],
    ["align", "list", "lineHeight"],
    ["outdent", "indent"],
    ["table", "horizontalRule", "link", "image", "imageGallery", "video", "audio"], // You must add the "imageGalleryUrl".
    // ['math'] //You must add the 'katex' library at options to use the 'math' plugin.
    ["fullScreen", "showBlocks", "codeView", "removeFormat"],
    ["preview", "print", "save"], //, "template"
  ],
};

export default EditorConfig;